import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Footer() {
  const { user } = useAuth();
  const [categories, setCategories] = useState([]);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/categories").then(({ data }) => setCategories(data)).catch(() => {});
  }, []);

  const subscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email: user ? undefined : email, source: "footer", url: window.location.href });
      toast.success("Абонирахте се успешно.");
      setEmail("");
    } catch (err) {
      toast.error(apiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#10243A] text-[#C8D3DC] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="font-serif text-2xl font-bold text-white mb-3">Metri<span className="text-[#C47A35]">.bg</span></div>
          <p className="text-sm leading-relaxed text-[#8FA2B3] max-w-xs">
            Медия на Investivo за недвижими имоти, инвестиции и икономика — фактите зад цифрите на пазара.
          </p>
        </div>
        <div>
          <h4 className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#C47A35] mb-5">Категории</h4>
          <div className="grid grid-cols-2 gap-2.5">
            {categories.slice(0, 10).map((c) => (
              <Link key={c.id} to={`/category/${c.slug}`} className="text-sm hover:text-white transition-colors" data-testid={`footer-category-${c.slug}`}>
                {c.name}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#C47A35] mb-5">Бюлетин за новини</h4>
          <p className="text-sm text-[#8FA2B3] mb-3">Пазарни новини всяка седмица.</p>
          <form onSubmit={subscribe} className="flex gap-2">
            {!user && (
              <Input
                type="email"
                required
                placeholder="имейл"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-[#17304B] border-white/15 text-white placeholder:text-[#64788A]"
                data-testid="footer-newsletter-input"
              />
            )}
            <Button type="submit" disabled={loading} className="bg-[#C47A35] hover:bg-[#A6631F] text-white rounded-none" data-testid="footer-newsletter-submit">
              {loading ? "..." : "Абонирай"}
            </Button>
          </form>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-[#64788A]">
        &copy; {new Date().getFullYear()} Metri.bg &mdash; част от екосистемата на Investivo
      </div>
    </footer>
  );
}
